import { Note, NoteTableActions } from '@/@types/note';
import { Table } from '@/components/common';
import { ColumnDefinitionType } from '@/components/common/Table/table.utils';
import { ITablePaginationProps } from '@/components/common/Table/TablePagination';
import { NOTE_TYPE_LABELS } from '@/modules/notes/constants';

import { NotesTableActions } from './NotesTableActions';

export const notesTableColumns: ColumnDefinitionType<Note>[] = [
  { key: 'id', header: 'ID', sort: 'id' },
  { key: 'title', header: 'Título', sort: 'title' },
  {
    key: 'type',
    header: 'Tipo',
    sort: 'type',
    render: ({ type }) => NOTE_TYPE_LABELS[type],
  },
  { key: 'createdAt', header: 'Criado em', sort: 'created_at' },
  {
    key: 'id',
    header: 'Ações',
    render: (props) => (
      <NotesTableActions {...(props as Note & NoteTableActions)} />
    ),
    width: '8rem',
    align: 'center',
    sticky: 'right',
  },
];

type NotesTableProps = {
  data: Note[];
  sort?: 'asc' | 'desc';
  sortBy?: string;
  // eslint-disable-next-line no-unused-vars
  onSort: (column: string) => void;
  actions: NoteTableActions;
  pagination: ITablePaginationProps;
};

export function NotesTable({
  data,
  sort,
  sortBy,
  onSort,
  actions,
  pagination,
}: NotesTableProps) {
  return (
    <Table
      data={data}
      columns={notesTableColumns}
      additionalData={actions}
      sort={sort}
      sortBy={sortBy as keyof Note}
      onSort={onSort}
      pagination={pagination}
    />
  );
}
